import { render, staticRenderFns } from "./ed-class-subject-placeholder-create-modal.component.vue?vue&type=template&id=414ef9a3&scoped=true&"
import script from "./ed-class-subject-placeholder-create-modal.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-subject-placeholder-create-modal.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-subject-placeholder-create-modal.component.scss?vue&type=style&index=0&id=414ef9a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414ef9a3",
  null
  
)

export default component.exports